import React from 'react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  // Optimized images with Cloudinary transforms
  const testimonials = [
    {
      quote: "We’ve worked with Living Media for a good while now. The edits are always solid, turned around quickly, and they’re easy to work with — which matters a lot on a busy sports desk.",
      author: "Thomas Clarke",
      role: "Sports Digital Editor, Golf Monthly",
      image: "https://res.cloudinary.com/digw3ykex/image/upload/f_auto,q_auto,w_100,h_100,c_fill/v1767275102/tom-clarke-2.jpeg.256x256_q100_crop-smart_ykmnfg.jpg"
    },
    {
      quote: "Living Media played a key role in helping me scale my personal brand past 50,000 new followers. Reliable, sharp execution. The team just understands modern content.",
      author: "GEORGE LEE",
      role: "CEO, TRUELEELIVING",
      image: "https://res.cloudinary.com/digw3ykex/image/upload/f_auto,q_auto,w_100,h_100,c_fill/v1767353537/images_1_jfop0u.jpg"
    },
    {
      quote: "Living Media have helped us out on ongoing video work and fast-moving news pieces. They’re reliable, react quickly, and understand what’s needed without overcomplicating things.",
      author: "Mark Evans",
      role: "Head of News, ENEX",
      image: "https://res.cloudinary.com/digw3ykex/image/upload/f_auto,q_auto,w_100,h_100,c_fill/v1767275101/images_r05e8n.jpg"
    }
  ];

  return (
    <section id="testimonials" className="bg-[#111] py-16 md:py-32 section-curve-up overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="mb-12 md:mb-24 flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
          <div>
            <span className="text-[#BEF264] font-black uppercase tracking-[0.3em] text-[11px] md:text-xs mb-3 md:mb-4 block italic">Testimonials</span>
            <h2 className="text-4xl md:text-7xl font-black text-white tracking-tighter leading-none uppercase">
              CLIENT <span className="italic text-white/20">VERDICTS.</span>
            </h2>
          </div>
          <div className="hidden md:block h-[1px] bg-white/10 flex-grow mx-12 mb-4" />
          <p className="text-white/40 max-w-sm font-medium uppercase text-[9px] md:text-xs tracking-widest leading-relaxed">
            Results matter. Opinion matters more. Here is what the elite say about our calibration.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 md:gap-12">
          {testimonials.map((t, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
              className="relative group bg-white/5 p-7 md:p-10 rounded-[2rem] md:rounded-[2.5rem] border border-white/5 hover:border-[#BEF264]/30 transition-all duration-500 flex flex-col"
            >
              <p className="text-base md:text-xl font-black text-white leading-snug mb-8 md:mb-12 uppercase italic tracking-tight">
                "{t.quote}"
              </p>
              
              <div className="flex items-center gap-4 mt-auto">
                <img 
                  src={t.image} 
                  alt={t.author} 
                  loading="lazy"
                  width="40"
                  height="40"
                  className="w-10 h-10 rounded-full grayscale group-hover:grayscale-0 transition-all duration-500 object-cover border border-white/10" 
                />
                <div>
                  <div className="text-white font-black uppercase tracking-widest text-[9px] md:text-xs">{t.author}</div>
                  <div className="text-[#BEF264] text-[8px] md:text-[10px] font-black uppercase tracking-widest opacity-60">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;